import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
export default {
  props: {
    type: Number // 0:提现页；1:主页

  },
  components: {
    Avatar: Avatar
  },
  mounted: function mounted() {
    // setTimeout(() => {
    window.bodymovin.loadAnimation({
      path: 'https://m.film.qq.com/vip-activity/kid-cny2021/lottie/header/data.json',
      loop: false,
      autoplay: true,
      renderer: 'svg',
      // 渲染方式，有"html"、"canvas"和"svg"三种
      container: this.$refs.head
    }); // }, 500);
  }
};